(function () {
  'use strict';

  var selector = 'img[data-jmt-secondary-image]';
  var hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

  function loadImage(image) {
    if (!image || image.hasAttribute('src')) return;
    var srcset = image.getAttribute('data-srcset');
    var src = image.getAttribute('data-src');
    if (srcset) image.setAttribute('srcset', srcset);
    if (src) image.setAttribute('src', src);
    image.removeAttribute('data-srcset');
    image.removeAttribute('data-src');
  }

  function loadImages(root) {
    if (!hoverQuery.matches) return;
    (root || document).querySelectorAll(selector).forEach(loadImage);
  }

  function watchProductGrid() {
    var container = document.getElementById('ProductGridContainer');
    if (!container || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () {
      loadImages(container);
    }).observe(container, { childList: true, subtree: true });
  }

  function initialize() {
    loadImages(document);
    watchProductGrid();
  }

  document.addEventListener('pointerover', function (event) {
    if (event.pointerType === 'touch') return;
    var card = event.target.closest && event.target.closest('[data-jmt-product-card]');
    if (card) card.querySelectorAll(selector).forEach(loadImage);
  }, { passive: true });

  document.addEventListener('shopify:section:load', function (event) {
    loadImages(event.target);
  });

  if (hoverQuery.addEventListener) {
    hoverQuery.addEventListener('change', function () {
      loadImages(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
